/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
==========================================================================================*/

import UnAuthActions from "./UnAuthActions";

import AuthAdminPanelFirstScreenActions from "./AuthAdminPanelFirstScreenActions";

import ProfileActions from "./ProfileActions";

import DashboardActions from "./DashboardActions";

import OrganizationsActions from "./OrganizationsActions";
import UsersActions from "./UsersActions";
import RolesActions from "./RolesActions";

import SearchActions from "./SearchActions";

import GoogleActions from "./GoogleActions";

import ClientActions from "./ClientActions";
import PaymentScheduleActions from "./PaymentScheduleActions";
import MonthlyPaymentScheduleActions from "./MonthlyPaymentScheduleActions";
import ClientAcquisitionActions from "./ClientAcquisitionActions";
import ImplementationActions from "./ImplementationActions";

import PaymentPurposeActions from "./PaymentPurposeActions";
import SourceActions from "./SourceActions";
import ClientTypeActions from "./ClientTypeActions";
import EmailBasicActions from "./EmailBasicActions";

import EventActions from "./EventActions";
import TasksActions from "./TasksActions";

import ActionActions from "./ActionActions";

import StarredPages from "./StarredPages";

import UiUx from "./UiUx";

import HelperActions from "./HelperActions";

const actions = Object.assign(
    UnAuthActions,

    AuthAdminPanelFirstScreenActions,

    ProfileActions,

    DashboardActions,

    OrganizationsActions,
    UsersActions,
    RolesActions,

    SearchActions,

	GoogleActions,

    ClientActions,
    PaymentScheduleActions,
    MonthlyPaymentScheduleActions,
    ClientAcquisitionActions,
    ImplementationActions,

    PaymentPurposeActions,
    SourceActions,
    ClientTypeActions,
    EmailBasicActions,

    EventActions,
    TasksActions,

    ActionActions,

    StarredPages,

    UiUx,

    HelperActions,
);

export default actions
